import Vue2TouchEvents from 'vue2-touch-events'

const defaultConfig = {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
  namespace: 'touch',
}

export default vueInstance => {
  try {
    vueInstance.use(Vue2TouchEvents, defaultConfig)
  } catch (e) {
    console.error('Touch Events: Error adds a disposable resource to the stack')
  }
}



// WEBPACK FOOTER //
// ./plugins/touch-events/index.js